export default __webpack_public_path__ + "static/media/explore7.8f382a5f.png";